module.exports = __webpack_public_path__ + "media/images/lig/products/lig-product-05-90c59b8c714a11b350b8ad26bd500d91.jpg";